import React, {useEffect} from "react";
import {useStateId} from "../../hooks/useStateId";
import {useConfig} from "../../config";
import {useVisualizerSession, useVisualizerStatus} from "../visualizer/VscVisualizerSession";

export const VscVideoPlayer: React.FC<{ videoName: string, videoTitle: string, looping?: boolean, session?: string }> = (props) => {

    const {videoName, videoTitle, session} = props;

    const sessionId = useStateId([videoName]);
    const mediaSession = useVisualizerSession();
    const mediaStatus = useVisualizerStatus();

    if (mediaSession === null) throw "Media session not initialized!";
    const {looping} = props;


    const sessionToUse = session ?? sessionId;
    useEffect(() => {
        if (mediaStatus?.sessionId === sessionToUse) {
            console.log('do nothing, this video is already playing!');
            return;
        }
        mediaSession.loadVideo(sessionToUse, videoName, videoTitle, !!looping);


        return () => {
            /*if (videoSession.videoControls === vc) {
                videoSession.videoControls = null;
            }*/
        }
    }, [sessionToUse]);


    return null;

}